'use client';

export { ContactWidgetComponent as ContactWidgetComponentB } from './ContactWidgetComponent';
